<template>
  <div>
    <div class="left-container">
      <case-module @select="select" @init="initModule" />
    </div>
    <div class="right-container">
      <div>
        <div class="view-tabs-content" style="background: #fff">
          <a-tabs v-model="viewType" @change="callback">
            <a-tab-pane key="table" tab="列表" />
            <a-tab-pane key="mind" tab="脑图" />
          </a-tabs>
        </div>
        <case-list v-show="viewType === 'table'" ref="case" />
        <MindView v-if="viewType === 'mind'" ref="mind" @saveOK="initMind" />
      </div>
    </div>
  </div>
</template>
<script>
import CaseList from '@/pages/project/case/components/CaseList';
import CaseModule from '@/pages/project/case/components/CaseModule';
import MindView from '@/pages/project/case/MindView';
export default {
  components: { CaseList, CaseModule, MindView },
  data() {
    return {
      nodeModuleData: {
        id: parseInt(this.$route.query.module_id) || null,
        project_id: parseInt(this.$route.params.project_id) || null
      },
      viewType: 'table',
      keys: []
    };
  },
  methods: {
    callback(key) {
      this.utils.trackClick({ name: '切换模式', label: key === 'mind' ? '脑图' : '列表' });
      this.viewType = key;
      if (key === 'mind') {
        this.$nextTick(() => {
          this.initMind();
        });
      } else if (key === 'table') {
        this.$refs['case'].setSelectModule(this.keys);
      }
    },
    initMind() {
      const _data = JSON.parse(JSON.stringify(this.nodeModuleData));
      this.$refs['mind'].initModule(_data);
    },
    initModule(keys, nodeModuleData) {
      this.keys = keys;
      this.nodeModuleData = nodeModuleData;
    },
    select(keys, nodeModuleData) {
      this.keys = keys;
      this.nodeModuleData = nodeModuleData;
      if (this.viewType === 'mind') {
        this.initMind();
      } else if (this.viewType === 'table') {
        this.$refs['case'].setSelectModule(keys);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.left-container {
  float: left;
  margin-right: 2px;
  margin-left: -16px;
  height: calc(~'100vh - 130px');
}
.right-container {
  position: relative;
  z-index: 10;
  display: block;
  // max-height: calc(~'100vh - 130px');
  height: calc(~'100vh - 130px');
  overflow: auto;
  border-radius: 2px;
}

/deep/.view-tabs-content {
  border-top: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  .ant-tabs-bar {
    margin: 0 !important;
  }

  .ant-tabs-tab {
    padding: 9px 16px;
  }
}
</style>
